import { render, staticRenderFns } from "./ProdutoAdm.vue?vue&type=template&id=1675165b&scoped=true&"
import script from "./ProdutoAdm.vue?vue&type=script&lang=js&"
export * from "./ProdutoAdm.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoAdm.vue?vue&type=style&index=0&id=1675165b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675165b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
